import { render } from "./HomeView.vue?vue&type=template&id=5ba8a756"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=5ba8a756&lang=css"
import "./HomeView.vue?vue&type=style&index=1&id=5ba8a756&lang=css"

import exportComponent from "/Users/romuloreis/Documents/CakeCherries/mural-viewer-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__